import {Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay} from 'swiper/modules';
import styles from "../styles/module/Home.module.css"
import '../styles/Home.css';
import {Swiper, SwiperSlide} from 'swiper/react';
import React, {useEffect, useState} from "react";
import gsap from "gsap";
import AboutComponent from "../components/About.jsx";
import AlbumComponent from "../components/Abum.jsx";
import {instagramLink} from "../components/layout/Header.jsx";
import {ContainerBooking} from "./Booking.jsx";
import {useNavigate} from "react-router-dom";

export const LogoMain1 = "assets/img/main/z4307300251583_3af3f1e2fd8768684b5c8cd821435240.jpg"
export const LogoMain2 = "assets/img/main/z4307299535479_df2a4c33481876080eeae435abd20660(2).jpg"
export const LogoMain3 = "assets/img/main/sushi-g86014edd4_1280.jpg"

function Home(props) {
    const [currentNumber, setCurrentNumber] = useState(1);
    const navigate = useNavigate();

    let effectStyle = {
        opacity: 1,
        x: 0,
        y: 0,
        ease: "power3.inOut",
        delay: 0.4,
        stagger: 0.2,
    }
    useEffect(() => {
        gsap.to(".swiper > .swiper-button-next-custom", 2, {...effectStyle, x: -10})
        gsap.to(".swiper > .swiper-button-prev-custom", 2, effectStyle)
        gsap.to(".swiper > .swiper-scrollbar-custom", 2, {...effectStyle, x: "0"})
    }, [])
    let headerConent = [
        {
            strong: ["Kando, wo Geschmack", "auf Kunst trifft"],
            title: "Erlebe Indochina"
        }, {
            strong: ["Kando, wo Geschmack", "auf Kunst trifft"],
            title: "Erlebe Indochina"
        }, {
            strong: ["Kando, wo Geschmack", "auf Kunst trifft"],
            title: "Erlebe Indochina"
        },
    ];

    let urls = [
        LogoMain1,
        LogoMain2,
        LogoMain3
    ];
    const handleClick = () => {
        let url = "/booking"
        navigate(url);
    }
    const handleOpenLink = () => {
        window.open("https://restaurant-kando-restaurant-freiberg.order.app.hd.digital/menus", "_blank");
    }
    return (
        <div>
            {/*, Autoplay*/}
            <div className="slider-container">

                <div className="sliders">
                    <Swiper
                        spaceBetween={50}
                        modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade]}
                        slidesPerView={1}

                        effect={"creative"}
                        loop={true}
                        speed={1500}
                        autoplay={{
                            delay: 5000,
                        }}
                        navigation={{
                            nextEl: '.swiper-button-next-custom',
                            prevEl: '.swiper-button-prev-custom'
                        }}
                        pagination={{
                            el: ".swiper-pagination",
                            clickable: true,
                            renderBullet: function (index, className) {
                                return '<span class="' + className + ' tab-' + (index + 1) + '">' + "</span>";
                            }
                        }}
                        scrollbar={{
                            el: '.swiper-scrollbar-custom',
                            draggable: true,
                            dragSize: 170
                        }}
                        onSwiper={(swiper) => {
                        }}
                        onSlideChange={(index) => {
                            setCurrentNumber(index.realIndex + 1);

                            const clearProps = {clearProps: "all"};

                            // Clear animations on previous and next slides (using clearProps AND increased specificity)
                            gsap.to(".swiper-slide-next > .wrap-slider > .infor-slide > *", {duration: 0, ...clearProps});
                            gsap.to(".swiper-slide-prev > .wrap-slider > .infor-slide > *", {duration: 0, ...clearProps});
                            gsap.to(".swiper-slide-prev > .wrap-slider > .infor-slide > .wrap-btn > *", {duration: 0, ...clearProps});
                            gsap.to(".swiper-slide-next > .wrap-slider > .infor-slide  > .wrap-btn > *", {duration: 0, ...clearProps});

                            //  VERY SPECIFIC selector for clearing  flex-string.  Include the .animationOne elements.
                            gsap.to(".swiper-slide-prev > .wrap-slider > .infor-slide > .header-h1 > .flex-string > * .animationOne", {duration: 0, ...clearProps});
                            gsap.to(".swiper-slide-next > .wrap-slider > .infor-slide > .header-h1 > .flex-string > * .animationOne", {duration: 0, ...clearProps});


                            // Animate in the active slide elements

                            gsap.to(".swiper-slide-active > .wrap-slider > .infor-slide > .sub-title", 0.5, effectStyle);
                            gsap.to(".swiper-slide-active > .wrap-slider > .infor-slide > .wrap-btn", 0.5, effectStyle);
                            gsap.to(".swiper-slide-active > .wrap-slider > .infor-slide > .wrap-btn > .hover-filled-slide-right", 1, {
                                ...effectStyle,
                                ease: "back",
                                delay: 0.5, // Reduced delay

                            });
                            gsap.to(".swiper-slide-active > .wrap-slider > .infor-slide > .header-h1", 0.5, effectStyle);
                            // More specific selector AND simplified timing for .animationOne animation
                            gsap.to(".swiper-slide-active > .flex-string > .header-h1 > * .animationOne", {
                                duration: 0.5,
                                opacity: 1,
                                x: 0,
                                y: 0,
                                ease: "back",
                                stagger: 0.1,
                                delay: 0.1,  //Reduced delay
                            });

                            gsap.to(".active-number", {duration: 0, y: -20, opacity: 0});
                            gsap.to(".active-number", 0.5, effectStyle);
                            gsap.to(".span-number-page", {duration: 0, y: -20, opacity: 0});
                            gsap.to(".span-number-page", 1.1, effectStyle);
                        }}
                    >

                        {
                            headerConent.map((item, index) => {
                                return (
                                    <SwiperSlide>
                                        <div className="wrap-slider">
                                            {/*<div className="logo">*/}
                                            {/*    <img src={linkLogoWhite} width={"50px"} height={"50px"}*/}
                                            {/*         alt=""/>*/}
                                            {/*</div>*/}

                                            <div className="thumbnail">
                                                <div className="over-play"></div>
                                                <img src={urls?.[index]} alt=""/>
                                            </div>
                                            <div className="infor-slide">
                                                <img src="/assets/img/main/main-hero-section.webp" alt=""/>

                                                <div>

                                                    <div className="sub-title">
                                                        {item.title}
                                                    </div>
                                                    <div className={"header-h1"}>

                                                        {item.strong.map((s) => {
                                                            return <strong className={"flex-string"}>
                                                                <TextSplitDiv title={s}/>
                                                            </strong>
                                                        })}

                                                    </div>
                                                    <div className={"wrap-btn"}>
                                                        <button className="hover-filled-slide-right"
                                                                onClick={handleClick}>
                                                            <span> Tisch reservieren</span>
                                                        </button>
                                                        <div className={"btn-img"}>
                                                            <img src="/assets/images/Vector-2.png" alt=""/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        }
                        <div className="swiper-pagination"></div>


                        <div className="swiper-scrollbar-custom"></div>


                        <div className="swiper-button-prev-custom">
                            PREV
                        </div>
                        <div className="swiper-button-next-custom">
                            NEXT
                        </div>
                        <div className="swiper-pagination swiper-pagination-nested"></div>
                    </Swiper>
                </div>
                <div className="count">
                    <div className="active-number">
                        {`0${currentNumber}`}
                    </div>
                    <span>
                        / 03
                    </span>
                </div>

            </div>

            <AboutComponent handleClick={handleClick} handleOpenLink={handleOpenLink}/>
            <ContainerBooking/>
            <div className={`${styles.orDivider} ${styles.justifyCenter}`}>
                <div className={styles.iconTitle}>
                    <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                         className=" "/>
                </div>
                <div className={styles.wrapOrDivider}>
                    Unser Social Feed
                    <img src="/assets/icon/svg/separator.svg" alt=""/>
                </div>
            </div>

            <div className={styles.wrapGalary}>
                <div className={styles.title}>
                    @zenchi_leipzig

                </div>
                <a className={styles.followBtn} href={instagramLink}>
                    Follow
                </a>
            </div>
            <AlbumComponent handleClick={handleClick} handleOpenLink={handleOpenLink}/>

            {/*<AboutComponent number={2}/>*/}


        </div>
    )
}

const TextSplitDiv = (props) => {
    let title = props?.title;
    let result = [];
    for (let i = 0; i < title.length; i++) {
        result.push(<span className={"animationOne"}>{title.charAt(i)}</span>)
    }
    return result
}
export default Home;